import SectionCard from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import { appstr } from "@coreapp/utils/appstr";
import { Flex } from "@theorgchartdev/storybook";
import * as React from "react";
import { FieldMappingRow } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/FieldMappingRow";
import {
  GetPromotedFields,
  GetRequiredFields
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/Utils";

export const EmployeeMappingSection = ({
  localConfig,
  BuildFieldMappingOptions,
  disableDropdowns,
  handleFieldRename,
  handleCustomFieldNameValidation
}) => {
  const requiredFields = GetRequiredFields(localConfig);
  const promotedFields = GetPromotedFields(localConfig);
  const displayFields = {};
  if (requiredFields) {
    if (Array.isArray(requiredFields)) {
      requiredFields.forEach(key => {
        displayFields[key] = null;
      });
    } else {
      Object.keys(requiredFields).forEach(key => {
        displayFields[key] = null;
      });
    }
  }

  if (promotedFields) {
    const requiredFieldKeys = Array.isArray(requiredFields)
      ? requiredFields
      : requiredFields
        ? Object.keys(requiredFields)
        : [];

    if (Array.isArray(promotedFields)) {
      promotedFields.forEach(key => {
        if (!requiredFieldKeys.includes(key)) {
          displayFields[key] = null;
        }
      });
    } else {
      Object.keys(promotedFields).forEach(key => {
        if (!requiredFieldKeys.includes(key)) {
          displayFields[key] = null;
        }
      });
    }
  }

  return (
    <SectionCard title={appstr("General field mapping")}>
      <Flex direction={"column"} gap={"16px"}>
        {Object.keys(displayFields).map(key => (
          <FieldMappingRow
            key={key}
            fieldKey={key}
            fieldValue={localConfig.fields ? localConfig.fields[key] : null}
            localConfig={localConfig}
            BuildFieldMappingOptions={BuildFieldMappingOptions}
            disabled={disableDropdowns}
            handleFieldRename={handleFieldRename}
            handleCustomFieldNameValidation={handleCustomFieldNameValidation}
            required={
              requiredFields &&
              (Array.isArray(requiredFields)
                ? requiredFields.includes(key)
                : Object.keys(requiredFields).includes(key))
            }
          />
        ))}
      </Flex>
    </SectionCard>
  );
};
